import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { NAV_LINKS, WHATSAPP_URL, WHATSAPP_NUMBER, scrollToHash } from "../lib/site";
import { Logo } from "./Logo";

const LEGAL = [
  { label: "Terms", to: "/terms" },
  { label: "Privacy", to: "/privacy" },
  { label: "Refund Policy", to: "/refund" },
  { label: "Contact", to: "/contact" },
];

export default function Footer() {
  return (
    <footer data-testid="footer-container" className="border-t border-[#E9DFFC] bg-white pb-28 pt-14 md:pb-14">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <div className="flex flex-col items-center gap-8 text-center md:flex-row md:items-start md:justify-between md:text-left">
          <div>
            <Logo />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#777181]">
              2-Day AI Digital Product Business Bootcamp — live online sessions in Hinglish with Anuj Tiwari.
            </p>
          </div>
          <nav aria-label="Footer" className="flex flex-col gap-2.5">
            <span className="font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-[#171321]">Explore</span>
            {NAV_LINKS.map((l) => (
              <a
                key={l.hash}
                href={l.hash}
                onClick={(e) => scrollToHash(e, l.hash)}
                className="text-sm font-medium text-[#777181] transition-colors hover:text-[#7C3AED]"
                data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {l.label}
              </a>
            ))}
          </nav>
          <nav aria-label="Legal" className="flex flex-col gap-2.5">
            <span className="font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-[#171321]">Legal</span>
            {LEGAL.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="text-sm font-medium text-[#777181] transition-colors hover:text-[#7C3AED]"
                data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {l.label}
              </Link>
            ))}
          </nav>
          <div className="flex flex-col gap-2.5">
            <span className="font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-[#171321]">Support</span>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
              className="inline-flex items-center gap-2.5 rounded-full border border-[#E9DFFC] bg-[#F6F1FF] px-5 py-2.5 text-sm font-bold text-[#171321] transition-[border-color,background-color] duration-200 hover:border-[#7C3AED]/40"
            >
              <MessageCircle size={16} className="text-[#7C3AED]" />
              {WHATSAPP_NUMBER}
            </a>
          </div>
        </div>
        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-[#E9DFFC] pt-6 text-xs text-[#777181] sm:flex-row">
          <span>© 2026 Digital Product Academy. All rights reserved.</span>
          <span>Individual results vary. This is an educational program, not an income opportunity.</span>
        </div>
      </div>
    </footer>
  );
}
